module.exports = __webpack_public_path__ + "static/blueboximage-ed2a160b57364d4e29c25071f1a6219f.png";